// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1MSIg","content":"styles_content__1WauB","checkbox":"styles_checkbox__3_4Sf","checkboxLabel":"styles_checkboxLabel__3FtIL"};